<template>
  <div
    class="height-all discover-page"
    :class="`${createRenderType}-discover-page`"
  >
    <PullTo
      :disabledRefresh="true"
      ref="pullRef"
      v-model:loadingMore="newSongsRnderData.loadingMore"
      v-model:isLoading="newSongsRnderData.isLoading"
      v-model:finished="newSongsRnderData.finished"
      :datas="newSongsRnderData.list"
      :showInfo="showInfo"
      @loadMore="doLoadMore"
    >
      <template #customContent>
        <div :class="`${createRenderType}-content-main`" class="content-main">
          <div v-if="createRenderType == 'mobile'" class="mobile-head">
            <SwiperBanner type="mobile"></SwiperBanner>
          </div>
          <IdeasBox
            v-if="isPartyAtheme || (!isPartyAtheme && !userDataStore.isLogin)"
          ></IdeasBox>
          <Trending
            :isPartyAtheme="isPartyAtheme"
            :loading="loading"
            @changeFavorite="changeFavorite"
            @handleShare="handleShare"
            @togglePlay="toggleTrendingPlay"
            @onCurPlayEnded="onCurPlayEnded"
            @handleSimilar="handleSimilar"
          ></Trending>
          <GenreList
            :loading="loading"
            @changeFavorite="changeFavorite"
            @handleShare="handleShare"
            @togglePlay="toggleGenrePlay"
            @onCurPlayEnded="onCurPlayEnded"
            @handleSimilar="handleSimilar"
          ></GenreList>
          <GenreCollection :loading="loading"></GenreCollection>
          <div class="flex1">
            <NewSongs
              :list="newSongsRnderData.list"
              @changeFavorite="changeFavorite"
              @handleShare="handleShare"
              @togglePlay="toggleNewSongsPlay"
              @onCurPlayEnded="onCurPlayEnded"
              @handleSimilar="handleSimilar"
            ></NewSongs>
          </div>
        </div>
      </template>
    </PullTo>
    <CreateSimilar ref="refCreateSimilar" source="home"></CreateSimilar>
    <h1 class="h1-seo">
      AI Generated Music Examples: Discover Innovative Compositions and Creative
      Soundscapes in Artificial Intelligence Music Production
    </h1>
    <div v-if="userDataStore.appLanguage=='en'" v-html="seoHtml" class="seo-html"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, getCurrentInstance } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { copyToClipboard } from "@/utils/tools";
import config from "@/config/config";
import globalConfig from "@/config/config.js";
import { favoriteSong } from "@/api/api/apiStore.js";
import useUserDataStore from "@/store/userDataStore";
import useDiscoverStore from "@/store/discover/discoverDataStore.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import { useDiscoverAsyncData } from "@/composables/useDiscoverAsyncData.js";
import message from "@/components/functionCallComponent/message.jsx";
import PullTo from "@/components/basic/pullTo/PullTo.vue";
import CreateSimilar from "@/page/create/createSimillar/createSimilar.vue";
import SwiperBanner from "../main/swiperBanner.vue";
import IdeasBox from "./components/ideasBox.vue";
import Trending from "./components/trending.vue";
import GenreList from "./components/genreList.vue";
import GenreCollection from "./components/genreCollection.vue";
import NewSongs from "./components/newSongs.vue";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { useSeoMeta, useHead } from "@unhead/vue";
import { seoHtml, seoHeader } from "./seo/seo.js"
import { renderAlternate } from "@/utils/tools.js"
const route = useRoute();

useHead({
  title: "AI Generated Music Examples: Find Inspiring AI Generated Music, Soundscapes, Creative Compositions, and Innovative AI Soundtracks | Mureka",
  meta: [
    { name: "description", content: "Mureka.ai: Explore and create AI-generated music examples. Transform your lyrics and prompts into unique, royalty-free songs with our advanced AI technology." },
    { property: "og:title", content: "AI Generated Music Examples - Mureka.ai" },
    { property: "og:description", content: "Discover how to create stunning AI-generated music with Mureka.ai. Our platform turns your ideas into unique songs across various genres. Start creating now!" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://www.mureka.ai/" },
    { property: "og:image", content: "https://mureka.ai/favicon.png" },
    { property: "og:image:alt", content: "Mureka.ai AI Music Generator" },
    { property: "og:site_name", content: "Mureka.ai" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: "AI Generated Music Examples - Mureka.ai" },
    { name: "twitter:description", content: "Create your own AI-generated music with Mureka.ai. From pop to hip-hop, make unique tracks with our advanced AI technology. Try it today!" },
    { name: "twitter:image", content: "https://mureka.ai/favicon.png" },
    { name: "twitter:image:alt", content: "Mureka.ai AI Music Generator" },
    { name: "twitter:site", content: "@Mureka_AI" },
  ],
  link: [
    { rel: "canonical", href: `${config.baseOrigin}/${(route.params?.lang ? `${route.params?.lang}/` : "" )}home` },
    ...renderAlternate('/home')
  ],
  script: [
    {
      innerHTML: seoHeader,
      type: "application/ld+json",
      tagPosition: "head",
    },
  ],
})
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n
const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const discoverDataStore = useDiscoverStore();
const globalPlayDataStore = useGlobalPlayDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { newSongsRnderData, trendingSongList } = storeToRefs(discoverDataStore);

const refCreateSimilar = ref(null);
const isPartyAtheme = ref(false);
const showInfo = reactive({
  networkerror: $$t("common.network_error"),
  loadfailure: $$t("common.load_failure"),
  contentviolation: $$t("common.content_violation"),
  emptydata: $$t("common.empty_data"),
});
const isMurekaCn = globalConfig.appname === "MurekaCn" ?? false;

const { loading } = useDiscoverAsyncData(discoverDataStore);

const doLoadMore = (done) => {
  discoverDataStore.doLoadMore(done);
};

//  做同款
const handleSimilar = (data) => {
  refCreateSimilar.value?.initSimilar(data);
};

// 点赞
const changeFavorite = async (item, favorite_state) => {
  const {
    song: { song_id },
  } = item;
  globalProperties?.logClickEvent("create_songlist_edit", {
    content_id: song_id,
    source: !favorite_state ? "like" : "cancel_like",
    tab_stare: "home",
    is_self: item?.user?.id == userDataStore?.userInfo?.user?.user_id ? 1 : 0,
  });

  if (!(await userDataStore.checkLoginStatus())) {
    return;
  }
  favoriteSong({
    song_id,
    state: favorite_state ? 2 : 1,
  }).then((res) => {
    if (res.code == 200) {
      message.success({
        position: "top",
        content: favorite_state ? $$t("editor.unlike") : $$t("editor.like"),
      });
      discoverDataStore.updateTrendingCardLike(item, favorite_state);
      discoverDataStore.updateGrnreLike(item, favorite_state);
      discoverDataStore.updateNewSongCardLike(item, favorite_state);
      changeGlobalFavoriteState(item, favorite_state);
    } else if (res.code == 6332) {
      message.error({
        maskClosable: true,
        position: "top",
        content: $$t("create.like_song_has_been_deleted"),
      });
    }
  });
};

// 修改全局播放器点赞状态
const changeGlobalFavoriteState = (item, state) => {
  globalPlayDataStore.updatePlayDataItem({
    ...item.song,
    uid: item.user.user_id,
    is_liked: state ? 2 : 1,
    is_disliked: 2,
    favorite_state: state ? 2 : 1,
  });
};

// 分享
const handleShare = async (data) => {
  const {
    song: { song_id, share_key },
  } = data;
  copyToClipboard(
      route.params.lang && route.params.lang!='en' ? `${config.baseOrigin}/${route.params.lang}/song-detail/${share_key}?is_from_share=1`:  `${config.baseOrigin}/song-detail/${share_key}?is_from_share=1`
  ).then((res) => {
    message.success({
      content: $$t("create.song_link_copied"),
    });
  });
  discoverDataStore
    .getShareKey(
      song_id,
      route.params.lang && route.params.lang!='en' ? `${config.baseOrigin}/${route.params.lang}/song-detail/${share_key}?is_from_share=1`:  `${config.baseOrigin}/song-detail/${share_key}?is_from_share=1`
    )
    .then((res) => {});
};

// 播放
const toggleTrendingPlay = (item) => {
  discoverDataStore.toggleTrendingPlay(item);
};

const toggleGenrePlay = (item) => {
  discoverDataStore.toggleGenrePlay(item);
};

const toggleNewSongsPlay = (item) => {
  discoverDataStore.toggleNewSongsPlay(item);
};

const onCurPlayEnded = (item) => {
  discoverDataStore.doPlayStateReport(item, 2);
};

onMounted(() => {
  const element = document.getElementsByClassName("mescroll_feed_list")[0];
  element.onscroll = function () {
    discoverDataStore.updateDiscoverScrollTop(element.scrollTop);
  };
  discoverDataStore.initPreviewList();
  // const isMatch = [
  //   "/create",
  //   "/library",
  //   "/subscribe",
  //   "/result-wait",
  //   "/liked",
  //   "/genre-detail",
  // ].some((item) => route.meta?.from.includes(item));
  // if (isMatch) {
  // } else {
  //   nextTick(() => {
  //     element.scrollTop = scrollHeight.value;
  //   });
  // }
  if (isMurekaCn) {
    nextTick(() => {
      const upwarp = document.querySelector(".mescroll_feed_list");
      if (upwarp) {
        upwarp.insertAdjacentHTML(
          "beforeend",
          '<div class="cn-bottom">京ICP备09007496号-32 网络文化经营许可证:京网文[2024]2379&#8209;<wbr>116号 版权所有◎昆仑万维科技股份有限公司 北京市东城区西总布胡同46号1幢3层320。京公网安备11010102007388号</div> '
        );
      }
    });
  }
});
</script>

<style lang="scss">
.pc-discover-page {
  overflow: auto;
  .mescroll {
    overflow: auto;
  }
}
.discover-page {
  .h1-seo {
    font-size: 0;
    height: 0;
  }
  .cn-bottom {
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 30px;
    color: rgba(255, 255, 255, 0.8);
    width: 100%;
    text-align: center;
    font-size: 10px;
    line-height: 15px;
    padding: 8px 20px;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0.8) 50%,
      rgba(0, 0, 0, 1) 100%
    );
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }
  .content-main {
    color: #fff;
    .mobile-head {
      // width: 343px;
      // padding: 0 16px ;
      margin: 0 18px;
      .main-nav-bottom-banner {
        margin: 20px 0 28px;
      }
    }
  }
  .pc-content-main {
    padding: 20px 0 20px 20px;
    min-width: unset;
    .title {
      font-size: 32px;
      font-weight: bold;
      line-height: 42px;
    }
  }
}
.mobile-discover-page {
  .cn-bottom {
    position: unset;
    background: unset;
    line-height: 1.2;
    x-ms-format-detection: none; /* 针对 IE/Edge */
    -webkit-touch-callout: none; /* 针对 iOS Safari */
  }
}
</style>
